import React, { useEffect, useRef, useState } from 'react'

import { Button, Card, Grid, Line, Span } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import Draggable from 'react-draggable'
import { COLORS, SPACING, TYPOGRAPHY } from 'utils'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled
} from './MultipleDaySelect.style'

interface IModalEditPendingItems {
  showMultipleDaySelect: boolean
  toggleModal: () => void
  selectedDays: any[]
  setSelectedDays: (_selectedDays: any[]) => void
}

const ModalEditPendingItems: React.FC<IModalEditPendingItems> = ({
  showMultipleDaySelect,
  selectedDays,
  setSelectedDays,
  toggleModal
}) => {
  const [monthToSelect, setMonthToSelect] = useState([])

  const alternateSelect = (index) => {
    monthToSelect[index].selected = !monthToSelect[index].selected
    setMonthToSelect((monthToSelect) => [...monthToSelect])
  }

  const handleClearCalendar = () => {
    monthToSelect.map((dayMonth) => {
      dayMonth.selected = false
    })
    setMonthToSelect((monthToSelect) => [...monthToSelect])
  }

  useEffect(() => {
    if (monthToSelect.length === 0) {
      for (let i = 1; i < 32; i++) {
        monthToSelect.push({
          day: i < 10 ? '0' + i.toString() : i.toString(),
          selected: false
        })
      }
    }

    const cpyArr = monthToSelect.slice()

    if (selectedDays.length > 0) {
      selectedDays?.map((currentDay) => {
        cpyArr[parseInt(currentDay) - 1].selected = true
      })
    }

    if (cpyArr.find((verifySelect) => verifySelect.selected)) {
      setMonthToSelect(cpyArr)
    }
  }, [showMultipleDaySelect])

  useEffect(() => {
    const tempVar = monthToSelect.filter((day) => day.selected)
    setSelectedDays(
      tempVar.map((dayMonth) => {
        return dayMonth.day
      })
    )
  }, [monthToSelect])

  const draggableReference = useRef<Draggable>(null)
  useEffect(() => {
    if (monthToSelect.length === 0) {
      for (let i = 1; i < 32; i++) {
        monthToSelect.push({
          day: i < 10 ? '0' + i.toString() : i.toString(),
          selected: false
        })
      }
    }
  }, [])

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={showMultipleDaySelect}
      onClose={toggleModal}
      width={'sm'}
    >
      <Line />
      <DialogTitleStyled>Selecione os dias do mês</DialogTitleStyled>
      <DialogContentStyled>
        <Grid
          gridCols="1fr 1fr 1fr 1fr 1fr 1fr 1fr"
          gridGap={`4px 4px`}
          margin={`${SPACING.spacing20} 0 0 0`}
        >
          {monthToSelect.map((dayMonth, index) => (
            <Card
              key={dayMonth.day}
              borderRadius="15px"
              backgroundColor={
                dayMonth.selected ? COLORS.blueFonts : COLORS.white
              }
            >
              <Span
                textAlign="center"
                marginTop={SPACING.spacing5}
                marginBottom={SPACING.spacing5}
                color={dayMonth.selected ? COLORS.white : COLORS.black}
                text={dayMonth.day}
                cursor="pointer"
                fontSize={TYPOGRAPHY.bodySize16}
                onClick={() => alternateSelect(index)}
              />
            </Card>
          ))}
        </Grid>
      </DialogContentStyled>
      <DialogActionsStyled>
        <Button
          text="limpar"
          variantButton="text"
          marginBottom={SPACING.spacing10}
          marginRight={SPACING.spacing5}
          onClick={handleClearCalendar}
        />
        <Button
          text="OK"
          marginBottom={SPACING.spacing10}
          marginRight={SPACING.spacing10}
          onClick={() => {
            toggleModal()
            resetModalState(draggableReference)
          }}
        />
      </DialogActionsStyled>
    </DraggableDialog>
  )
}

export default ModalEditPendingItems
